import { useMutation, gql } from '@apollo/client';
import {
  DeletarCursoMutation,
  DeletarCursoMutationVariables,
} from './__generated__/DeletarCursoMutation';

const DELETAR_CURSO_MUTATION = gql`
  mutation DeletarCursoMutation($id_curso: Int!) {
    deletarCurso(id_curso: $id_curso) {
      id_curso
    }
  }
`;

const useDeletarCursoMutation = () => {
  return useMutation<DeletarCursoMutation, DeletarCursoMutationVariables>(DELETAR_CURSO_MUTATION);
};

export { useDeletarCursoMutation };
